import { render, staticRenderFns } from "./VueSelectSize.vue?vue&type=template&id=2e63f87c"
import script from "./VueSelectSize.vue?vue&type=script&lang=js"
export * from "./VueSelectSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports